import { ApiConfig, HttpMethod, DynamicUrl, MICRO_SERVER_URL_CASE, MICRO_SERVER_URL_TAGS } from '../constant';

const URL_FIELDS = `${MICRO_SERVER_URL_CASE}/meta/fields`;
const URL_DEPENDENT_FIELDS = `${MICRO_SERVER_URL_CASE}/meta/dependent-fields`;
const URL_FORMS = `${MICRO_SERVER_URL_CASE}/meta/forms`;
const URL_TAGS = `${MICRO_SERVER_URL_TAGS}/core/tags`;
const URL_DICTS = `${MICRO_SERVER_URL_CASE}/meta/dicts`;

/* case fields */
export const caseFields: ApiConfig = {
  url: `${URL_FIELDS}`,
};

export const caseFieldsCreate: ApiConfig = {
  url: `${URL_FIELDS}`,
  headers: { 'api-version': '2' },
  method: HttpMethod.POST,
};

export const caseFieldsUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_FIELDS}/${String(id)}`,
  headers: { 'api-version': '2' },
  method: HttpMethod.PATCH,
};

export const caseFieldsDelete: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_FIELDS}/${String(id)}`,
  method: HttpMethod.DELETE,
};

export const caseFieldsDetail: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_FIELDS}/${String(id)}`,
};

export const caseFieldsWithOptions: ApiConfig = {
  url: `${URL_FIELDS}/with-options`,
};

/* case dependent fields */
export const caseDependentFieldsUpload: ApiConfig = {
  url: `${URL_DEPENDENT_FIELDS}`,
  method: HttpMethod.POST,
};

/* case forms */
export const caseForms: ApiConfig = {
  url: `${URL_FORMS}/list`,
};

export const caseFormsCreate: ApiConfig = {
  url: `${URL_FORMS}`,
  method: HttpMethod.POST,
};

export const caseFormsClone: ApiConfig = {
  url: `${URL_FORMS}/clone`,
  method: HttpMethod.POST,
};

export const caseFormsUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_FORMS}/${String(id)}`,
  method: HttpMethod.PATCH,
};

export const caseFormsSort: ApiConfig = {
  url: `${URL_FORMS}`,
  method: HttpMethod.PATCH,
};

export const caseFormsDetail: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_FORMS}/${String(id)}`,
};

export const caseFormsDetailWithHistory: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_FORMS}/detail/${String(id)}`,
  cancelPrev: false,
};

export const caseFormsDelete: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_FORMS}/${String(id)}`,
  method: HttpMethod.DELETE,
};

/* case tags */
export const caseTagsWithPage: ApiConfig = {
  url: `${URL_TAGS}`,
};

export const caseTagsAutocomplete: ApiConfig = {
  url: `${URL_TAGS}/autocomplete`,
};

/* dicts */
export const dicts: ApiConfig = {
  url: `${URL_DICTS}`,
};
